

















































































































import { natureOptions } from '@/utils/universal-variable';
import { getAgentInfoApi } from '@/api/company';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'contactPerson',
})
export default class extends Vue {

  get location() {
    if (this.detail) {
      const { countryName, stateName, cityName } = this.detail;
      return `${countryName || ''}${stateName || ''}${cityName || ''}`;
    }
    return '';
  }

  get nature() {
    if (this.detail) {
      const { nature } = this.detail;
      const data = natureOptions.find((item) => item.id === nature);
      return data ? data.label : '';
    }
    return '';
  }

  public detail: any = null;

  public mounted() {
    this.getAgentInfo();
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      vm.getAgentInfo();
    });
  }

  public async getAgentInfo() {
    const { data } = await getAgentInfoApi();
    this.detail = data.data;
  }
}
